export  const language_vi= {
    "nav.home": "Trang Chủ",
    "nav.cexs": "Sàn & Core Team",
    "nav.operations": "Thao tác",
    "nav.transactions": "Giao Dịch",
    "nav.blocks": "Khối",
    "nav.nodes": "Các Node",
    "nav.nodes_mainnet": "Node Mainnet",
    "nav.nodes_testnet": "Node Testnet",
    "nav.stats": "Thống Kê",
    "nav.defi": "DeFi",
    "nav.assets": "Tài sản",
    "nav.pools": "Pools",
    "nav.trades": "Giao dịch",
    "stats.accounts": "Phân Bố Tài Khoản",
    "stats.unlocks": "Mở Khóa Pi 30 Ngày",
    "stats.unlocks_monthly": "Mở Khóa Pi Hàng Tháng",
    'stats.domain_auction': 'Thống kê Đấu giá Tên miền',
    'stats.largest_tx': 'Giao Dịch Lớn Nhất',
    'stats.migrate': 'Thống kê di chuyển mainnet',
    "search.placeholder": "Tìm kiếm...",
    'operations.self_transfer': 'Tự Chuyển',
    'operations.domain_auction': 'Đấu Giá Tên Miền',
    "operations.claim_claimable_balance": "Nhận π",
    "operations.create_account": "Tạo Tài Khoản",
    "operations.payment": "Thanh Toán",
    "operations.path_payment_strict_receive": "Thanh Toán Đường Dẫn Nhận Nghiêm Ngặt",
    "operations.path_payment_strict_send": "Thanh Toán Đường Dẫn Gửi Nghiêm Ngặt",
    "operations.manage_sell_offer": "Quản Lý Đề Xuất Bán",
    "operations.create_passive_sell_offer": "Tạo Đề Xuất Bán Thụ Động",
    "operations.set_options": "Đặt Tùy Chọn",
    "operations.change_trust": "Thay Đổi Tin Cậy",
    "operations.allow_trust": "Cho Phép Tin Cậy",
    "operations.account_merge": "Hợp Nhất Tài Khoản",
    "operations.inflation": "Lạm Phát",
    "operations.manage_data": "Quản Lý Dữ Liệu",
    "operations.bump_sequence": "Tăng Chuỗi",
    "operations.manage_buy_offer": "Quản Lý Đề Xuất Mua",
    "operations.create_passive_buy_offer": "Tạo Đề Xuất Mua Thụ Động",
    "operations.create_claimable_balance": "Tạo Số Dư Có Thể Nhận",
    "operations.claim_claimable_balance_atom": "Nhận Số Dư",
    "operations.deposit": "Nạp",
    "operations.withdraw": "Rút",
    "operations.pay": "Thanh toán",
    "operations.to": "đến",
    "operations.from": "từ",
    "operations.claimant": "Người nhận",
    "operations.with_starting_balance": "với số dư ban đầu",
    "operations.claim": "Nhận",
    "operations.heading": "Khám phá các thao tác mới nhất trên blockchain Pi Network",
    "operations.title": "Các thao tác mới nhất trên Pi Network",
    "operations.description": "Khám phá các thao tác mới nhất trên blockchain Pi Network.",
    "operations.source_account": "Tài khoản nguồn",
    "operations.operation": "Thao tác",
    "operations.amount": "Số lượng",
    "operations.tx": "Giao dịch",
    "operations.time": "Thời gian",
    "pagination.previous": "Trước",
    "pagination.next": "Tiếp",
    "pagination.page": "Trang",
    "account.title": "Tài khoản {{address}} - Pi Network Explorer",
    "account.heading": "Chi tiết Tài Khoản",
    "account.heading_with_address": "Tài khoản {{address}}",
    "account.description": "Chi tiết của Tài khoản {{address}} trên mạng Pi Network.",
    "account.loading": "Đang tải chi tiết tài khoản...",
    "account.not_found": "Không tìm thấy tài khoản.",
    "account.scam_warning_title": "Cảnh báo lừa đảo",
    "account.scam_warning_description": "Địa chỉ ví này đã bị đánh dấu là không an toàn dựa trên báo cáo của cộng đồng. Nó có thể liên quan đến lừa đảo, khóa riêng tư bị xâm phạm hoặc truy cập trái phép. Hãy thận trọng trước khi thực hiện bất kỳ giao dịch nào.",
    "account.overview": "Tổng quan",
    "account.available_balance": "Số dư khả dụng",
    "account.last_modified_time": "Thời gian sửa đổi cuối",
    "account.locking": "Đang khóa",
    "account.total_locking": "Tổng số khóa ({{count}} mục)",
    "account.next_unlock_time": "Thời gian mở khóa tiếp theo",
    "account.claimable": "Có thể nhận",
    "account.amount": "Số lượng",
    "account.number_of_items": "Số lượng mục",
    "account.over_100_items": "hơn 100 mục",
    "account.tx_hash": "Mã giao dịch",
    "account.operation_count": "Số lượng thao tác",
    "account.fee": "Phí",
    "account.created_at": "Tạo lúc",
    "account.account": "Tài khoản",
    "account.effect": "Tác động",
    "account.sponsor": "Nhà tài trợ",
    "account.predicate": "Điều kiện",
    "account.create_time": "Thời gian tạo",
    "account.latest_100_claimable": "100 số dư có thể nhận mới nhất",
    "account.tabs.operations": "Các thao tác",
    "account.tabs.transactions": "Giao dịch",
    "account.tabs.effects": "Tác động",
    "account.tabs.claimable_balances": "Số dư có thể nhận",
    "effects.account_credited": "Tài khoản được ghi có",
    "effects.account_debited": "Tài khoản bị ghi nợ",
    "effects.account_created": "Tài khoản được tạo",
    "effects.claimable_balance_created": "Số dư có thể nhận đã được tạo",
    "effects.claimable_balance_claimed": "Số dư có thể nhận đã được nhận",
    "effects.claimable_balance_claimant_created": "Người nhận số dư đã được tạo",
    "effects.account_removed": "Tài khoản bị xóa",
    "effects.account_thresholds_updated": "Ngưỡng tài khoản được cập nhật",
    "effects.account_home_domain_updated": "Tên miền chính của tài khoản được cập nhật",
    "effects.account_flags_updated": "Cờ tài khoản được cập nhật",
    "effects.account_inflation_destination_updated": "Điểm đến lạm phát tài khoản được cập nhật",
    "effects.signer_created": "Người ký được tạo",
    "effects.signer_removed": "Người ký bị xóa",
    "effects.signer_updated": "Người ký được cập nhật",
    "effects.trustline_created": "Đường tin cậy được tạo",
    "effects.trustline_removed": "Đường tin cậy bị xóa",
    "effects.trustline_updated": "Đường tin cậy được cập nhật",
    "effects.trustline_authorized": "Đường tin cậy được ủy quyền",
    "effects.trustline_deauthorized": "Đường tin cậy bị hủy ủy quyền",
    "effects.offer_created": "Đề xuất được tạo",
    "effects.offer_removed": "Đề xuất bị xóa",
    "effects.offer_updated": "Đề xuất được cập nhật",
    "effects.trade": "Giao dịch được thực hiện",
    "effects.data_created": "Dữ liệu được tạo",
    "effects.data_removed": "Dữ liệu bị xóa",
    "effects.data_updated": "Dữ liệu được cập nhật",
    "effects.sequence_bumped": "Chuỗi được nâng",
    "effects.liquidity_pool_created": "Pool thanh khoản được tạo",
    "effects.liquidity_pool_removed": "Pool thanh khoản bị xóa",
    "effects.liquidity_pool_deposited": "Pool thanh khoản được gửi tiền",
    "effects.liquidity_pool_withdrew": "Rút tiền từ pool thanh khoản",
    "effects.liquidity_pool_trade": "Giao dịch pool thanh khoản",
    "effects.liquidity_pool_revoked": "Pool thanh khoản bị thu hồi",
    "effects.contract_credited": "Hợp đồng được ghi có",
    "effects.contract_debited": "Hợp đồng bị ghi nợ",
    "effects.claimable_balance_sponsorship_removed": "Tài trợ số dư có thể nhận đã bị xóa",
    "account_stats.heading": "Thống Kê Tài Khoản Pi - Phân Phối Số Dư & Tài Khoản Hàng Đầu",
    "account_stats.title": "Thống Kê Tài Khoản Pi - Phân Phối Số Dư & Tài Khoản Hàng Đầu",
    "account_stats.description": "Xem các tài khoản Pi giàu nhất và phân phối số dư tổng thể trên mạng Pi.",
    "account_stats.intro_text": "Khám phá sự phân phối của Pi trên tất cả các tài khoản và xem những người nắm giữ Pi hàng đầu.",
    "account_stats.distribution_chart_title": "Phân Phối Người Nắm Giữ Pi",
    "account_stats.categories_title": "Danh Mục Phân Phối",
    "account_stats.top_accounts_title": "Tài Khoản Pi Hàng Đầu",
    "account_stats.accounts": "tài khoản",
    "account_stats.of_total": "của tổng số",
    "account_stats.table.category": "Danh mục",
    "account_stats.table.balance_range": "Phạm vi số dư",
    "account_stats.table.usd_value": "Giá trị USD",
    "account_stats.table.accounts": "Tài khoản",
    "account_stats.table.percentage": "% tổng số",
    "account_stats.table.total": "Tổng cộng",
    "account_stats.table.rank": "Hạng",
    "account_stats.table.account": "Tài khoản",
    "account_stats.table.balance": "Số dư",
    "account_stats.table.value": "Giá trị",
    "account_stats.table.supply_percentage": "% lượng cung",
    "account_stats.categories.whales": "Cá Voi",
    "account_stats.categories.sharks": "Cá Mập",
    "account_stats.categories.dolphins": "Cá Heo",
    "account_stats.categories.tunas": "Cá Ngừ",
    "account_stats.categories.fish": "Cá",
    "account_stats.categories.shrimps": "Tôm",
    "account_stats.categories.plankton": "Sinh Vật Phù Du",
    "account_stats.categories.microbes": "Vi Sinh Vật",
    "number.billion_short": "Tỷ",
    "number.million_short": "Tr",
    "number.thousand_short": "N",
    "common.loading": "Đang tải...",
    "common.sponsored": "Tài trợ",
    "common.ad": "Quảng cáo",
    "common.ad_not_available": "Nội dung được tài trợ không có sẵn trong khu vực của bạn",
    "blocks.heading": "Khám phá các khối mới nhất trên blockchain Pi Network",
    "blocks.title": "Các Khối Mới Nhất trên Pi Network",
    "blocks.description": "Khám phá các khối mới nhất trên blockchain Pi Network.",
    "blocks.sequence": "Chuỗi",
    "blocks.hash": "Mã băm",
    "blocks.transactions": "Giao dịch",
    "blocks.operations": "Thao tác",
    "blocks.time": "Thời gian",
    "blocks.successful": "thành công",
    "blocks.failed": "thất bại",
    "block.title": "Khối #{{sequence}} - Pi Network Explorer",
    "block.heading": "Khối #{{sequence}}",
    "block.description": "Chi tiết của Khối #{{sequence}} trên mạng lưới Pi Network.",
    "block.loading": "Đang tải chi tiết khối...",
    "block.not_found": "Không tìm thấy khối.",
    "block.information": "Thông tin khối",
    "block.hash": "Mã băm",
    "block.previous_hash": "Mã băm trước đó",
    "block.sequence": "Chuỗi",
    "block.time": "Thời gian",
    "block.total_coins": "Tổng số coin",
    "block.fee_pool": "Quỹ phí",
    "block.base_fee": "Phí cơ bản",
    "block.base_reserve": "Dự trữ cơ bản",
    "block.protocol_version": "Phiên bản giao thức",
    "block.tx_hash": "Mã giao dịch",
    "block.operation_count": "Số lượng thao tác",
    "block.fee": "Phí",
    "block.created_at": "Tạo lúc",
    "block.tabs.transactions": "Giao dịch",
    "block.tabs.operations": "Thao tác",
    "block.tabs.effects": "Tác động",
    "cex.heading": "Thống kê tài khoản sàn giao dịch & Đội ngũ lõi",
    "cex.title": "Tài khoản CEX & Đội ngũ lõi trên Pi Network",
    "cex.description": "Khám phá tài khoản CEX & Đội ngũ lõi trên blockchain Pi Network.",
    "cex.wallet_balances": "Số dư ví của các CEX",
    "cex.core_team_wallets": "Ví của đội ngũ lõi Pi",
    "cex.cmc_ranking": "Xếp hạng CMC",
    "cex.exchange": "Sàn giao dịch",
    "cex.chart_link": "Link biểu đồ",
    "cex.signup_link": "Link đăng ký",
    "cex.wallet_address": "Địa chỉ ví",
    "cex.balance_pi": "Số dư (Pi)",
    "cex.balance_usd": "Số dư (USD)",
    "cex.chart": "Biểu đồ",
    "cex.signup": "Đăng ký",
    "cex.total": "Tổng cộng",
    "cex.note": "Ghi chú",
    "cex.pi_foundation": "Pi Foundation",
    "cex.team_wallet_footnote": "Có khoảng 10.000 tài khoản được gắn nhãn thuộc về Đội ngũ lõi Pi không được liệt kê ở đây do số lượng lớn và rất ít giao dịch. Mỗi ví chứa khoảng 2.000.000 Pi, tổng cộng khoảng 20 tỷ Pi chưa được tính đến",
   'cex.total_in': 'Tiền vào (24h gần nhất)',
'cex.total_out': 'Tiền ra (24h gần nhất)',
'cex.net_difference': 'Dòng tiền ròng (24h gần nhất)',
'cex.flow_data_updated': 'Dữ liệu cập nhật mỗi 30 phút',


    "contact.heading": "Liên Hệ Với Chúng Tôi",
    "contact.title": "Liên Hệ PiScan",
    "contact.description": "Liên hệ PiScan cho bất kỳ câu hỏi hoặc phản hồi nào.",
    "contact.intro_text": "Nếu bạn có bất kỳ câu hỏi nào, hãy liên hệ với chúng tôi tại",
    "contact.success_message": "Cảm ơn bạn đã liên hệ với chúng tôi! Chúng tôi sẽ phản hồi sớm.",
    "contact.form.name": "Tên Của Bạn",
    "contact.form.email": "Email Của Bạn",
    "contact.form.message": "Tin Nhắn",
    "contact.form.submit": "Gửi Tin Nhắn",
    "home.heading": "Khám phá giao dịch, ví và thống kê Mạng Pi",
    "home.title": "Khám phá giao dịch, ví và thống kê Mạng Pi",
    "home.description": "Khám phá giao dịch, ví và thống kê trên Mạng Pi",
    "home.market_cap": "Vốn hoá thị trường",
    "home.price": "Giá",
    "home.24h_change": "24h%",
    "home.pi_supply": "Tổng cung",
    "home.circulating": "Đang lưu hành",
    "home.locked": "Đang khóa",
    "home.cex_balance_total": "Số dư CEX (tổng)",
    "home.view_all": "Xem tất cả",
    "home.network_stats": "Thống kê mạng",
    "home.blocks": "Các khối",
    "home.tps": "GD/giây",
    "home.latest_transactions": "Giao dịch mới nhất",
    "home.signature": "Chữ ký",
    "home.time": "Thời gian",
    "home.block": "Khối",
    "home.ops": "Thao tác",
    "home.latest_operations": "Thao tác mới nhất",
    "home.source_account": "Tài khoản nguồn",
    "home.operation": "Thao tác",
    "home.amount": "Số lượng",
    "home.tx": "Giao dịch",
    "nodes.heading": "Bản Đồ Node & Thống Kê Mạng Pi Network",
    "nodes.title": "Các Node & Validator Của Pi Network",
    "nodes.description": "Khám phá các node, validator và cấu trúc liên kết mạng Pi Network. Xem phân bố và kết nối toàn cầu của các node.",
    "nodes.active_nodes": "Node Hoạt Động",
    "nodes.validators": "Validator",
    "nodes.known_peers": "Các peer đã biết",
    "nodes.disconnected_nodes": "Node Mất Kết Nối",
    "nodes.network_graph": "Biểu Đồ Mạng",
    "nodes.node_types": "Loại Node",
    "nodes.validator": "Validator",
    'nodes.phantom_validators': 'Validator không thể kết nối',
    "nodes.watcher": "Watcher",
    "nodes.disconnected_private": "Mất Kết Nối/Riêng Tư",
    "nodes.click_to_highlight": "Nhấp vào node để làm nổi bật các kết nối của nó",
    "nodes.global_distribution": "Phân Bố Toàn Cầu",
    "nodes.mapped_nodes": "Các node đã được lập bản đồ",
    "nodes.node_details": "Chi Tiết Node",
    "nodes.nodes": "Node",
    "nodes.address": "Địa chỉ",
    "nodes.type": "Loại",
    "nodes.location": "Vị trí",
    "nodes.isp": "Nhà cung cấp",
    "nodes.version": "Phiên bản",
    "nodes.trust": "Tin cậy",
    "nodes.trusted_by": "Được tin cậy bởi",
    "nodes.status": "Trạng thái",
    "nodes.status.connected": "Đã kết nối",
    "nodes.status.disconnected": "Mất kết nối",
    "nodes.status.private": "Riêng tư",
    "nodes.active_quorum_sets": "Các bộ quorum đang hoạt động",
    "nodes.active": "hoạt động",
    "nodes.quorum_hash": "Mã băm số phiếu",
    "nodes.node_id": "ID Node",
    "nodes.unknown": "Không xác định",
    "nodes.core_team": "Đội ngũ lõi",
    "nodes.tooltip.node_id": "ID Node",
    "nodes.tooltip.address": "Địa chỉ",
    "nodes.tooltip.type": "Loại",
    "nodes.tooltip.status": "Trạng thái",
    "nodes.tooltip.version": "Phiên bản",
    "nodes.tooltip.location": "Vị trí",
    "nodes.tooltip.not_accessible": "Không thể truy cập",
    "nodes.country_statistics": "Thống Kê Quốc Gia",
    "nodes.country": "Quốc Gia",
    "nodes.connected_nodes": "Node Đã Kết Nối",
    "nodes.no_country_data": "Không có dữ liệu quốc gia",
    "nodes.city_statistics": "Thống Kê Thành Phố",
    "nodes.city": "Thành Phố",
    "nodes.no_city_data": "Không có dữ liệu thành phố",
    "nodes.online_nodes_only": "Chỉ Node Online",
    
    // Bản dịch Nodes Testnet
    "nodes_testnet.heading": "Thống Kê Node Pi Testnet & Phân Tích Mạng",
    "nodes_testnet.title": "Node Pi Testnet & Thống Kê Mạng",
    "nodes_testnet.description": "Khám phá thống kê node Pi Testnet, phân bố địa lý và các chỉ số hoạt động mạng.",
    "nodes_testnet.total_nodes": "Tổng Số Node",
    "nodes_testnet.active_nodes": "Node Hoạt Động",
    "nodes_testnet.inactive_nodes": "Node Không Hoạt Động",
    "nodes_testnet.last_updated": "Cập Nhật Lần Cuối",
    "nodes_testnet.country_statistics": "Thống Kê Quốc Gia",
    "nodes_testnet.city_statistics": "Thống Kê Thành Phố",
    "nodes_testnet.country": "Quốc Gia",
    "nodes_testnet.city": "Thành Phố",
    "nodes_testnet.active_rate": "Tỷ Lệ Hoạt Động",
    "nodes_testnet.summary_title": "Tổng Quan Mạng",
    "nodes_testnet.summary_description": "Tổng quan về phân bố node Pi Testnet và hoạt động trên mạng toàn cầu.",
    "nodes_testnet.total_peers": "Tổng Peer",
    "nodes_testnet.active_peers": "Peer Hoạt Động",
    "nodes_testnet.activity_rate": "Tỷ Lệ Hoạt Động",
    
    "report_scam.heading": "Báo Cáo Ví Lừa Đảo",
    "report_scam.title": "Báo Cáo Ví Lừa Đảo Trên PiScan",
    "report_scam.description": "Báo cáo địa chỉ ví liên quan đến hoạt động lừa đảo hoặc gian lận.",
    "report_scam.intro_text": "Nếu bạn đã gặp phải địa chỉ ví đáng ngờ liên quan đến các hoạt động gian lận hoặc lừa đảo, vui lòng báo cáo bằng biểu mẫu dưới đây. Đội ngũ của chúng tôi sẽ xem xét báo cáo và nếu xác nhận là lừa đảo, chúng tôi sẽ đánh dấu ví là \"Lừa đảo\" trên PiScan để cảnh báo cộng đồng.",
    "report_scam.success_message": "Cảm ơn báo cáo của bạn! Đội ngũ của chúng tôi sẽ xem xét nhanh nhất có thể.",
    "report_scam.form.wallet_address": "Địa Chỉ Ví",
    "report_scam.form.wallet_placeholder": "Nhập địa chỉ ví lừa đảo",
    "report_scam.form.reason": "Lý Do Báo Cáo",
    "report_scam.form.reason_placeholder": "Mô tả lý do ví này bị nghi ngờ có hoạt động lừa đảo",
    "report_scam.form.email": "Email Của Bạn (Tùy Chọn)",
    "report_scam.form.email_placeholder": "Nhập email của bạn (tùy chọn)",
    "report_scam.form.email_note": "Chúng tôi có thể liên hệ với bạn để biết thêm chi tiết.",
    "report_scam.form.submit": "Gửi Báo Cáo",
    "transaction.title": "Giao dịch #{{id}} trên Pi Network",
    "transaction.heading": "Chi tiết giao dịch",
    "transaction.description": "Chi tiết của giao dịch #{{id}} trên blockchain Pi Network.",
    "transaction.loading": "Đang tải chi tiết giao dịch...",
    "transaction.not_found": "Không tìm thấy giao dịch.",
    "transaction.hash": "Mã băm",
    "transaction.ledger_block": "Sổ cái (Khối)",
    "transaction.result": "Kết quả",
    "transaction.source_account": "Tài khoản nguồn",
    "transaction.fee_account": "Tài khoản phí",
    "transaction.fee": "Phí",
    "transaction.operation_count": "Số lượng thao tác",
    "transaction.summary": "Tóm tắt",
    "transaction.operations": "Thao tác",
    "transaction.effects": "Hiệu ứng",
    "transaction.account": "Tài khoản",
    "transaction.operation": "Thao tác",
    "transaction.effect": "Hiệu ứng",
    "transaction.amount": "Số lượng",
    "transaction.successful": "Thành công",
    "transaction.failed": "Thất bại",
    "transaction.loading_details": "Đang tải chi tiết giao dịch...",
    "transaction.with_operations": "Giao dịch với {{count}} thao tác",
    "transaction.core_team_distributed": "Đội ngũ lõi Pi đã phân phối",
    "transaction.to": "cho",
    "transaction.accounts": "tài khoản",
    "transaction.locked_for_days": ", khóa trong {{days}} ngày",
    "transaction.locked_range_days": ", với thời gian khóa từ {{minDays}} đến {{maxDays}} ngày",
    "transaction.created_at": "Thời gian tạo",
    "unlock_stats.heading": "Thống Kê Mở Khóa Pi - 30 Ngày Tới",
    "unlock_stats.title": "Thống Kê Mở Khóa Pi - 30 Ngày Tới",
    "unlock_stats.description": "Xem thống kê dự kiến mở khóa tiền điện tử Pi trong 30 ngày tới.",
    "unlock_stats.intro_text": "Mở khóa Pi trong 30 ngày tới dựa trên số dư có thể nhận—do người dùng khóa hoặc do Đội ngũ Pi Core phân phối. Pi chưa phát hành trong số dư có thể nhận không thể theo dõi được. Kiểm tra thường xuyên để cập nhật. Tất cả thời gian là UTC.",
    "unlock_stats.today_note": "Số lượng mở khóa hôm nay đại diện cho Pi còn lại sẽ được mở khóa từ bây giờ cho đến cuối ngày (UTC).",
    "unlock_stats.updated_at": "Dữ liệu cập nhật vào:",
    "unlock_stats.unknown": "Không xác định",
    "unlock_stats.total_locked": "Tổng Pi Đang Khóa",
    "unlock_stats.total_next_30": "Tổng Mở Khóa 30 Ngày Tới",
    "unlock_stats.of_total_locked": "của tổng khóa",
    "unlock_stats.avg_daily": "Mở Khóa Trung Bình Hàng Ngày",
    "unlock_stats.per_day": "mỗi ngày",
    "unlock_stats.highest_day": "Ngày Cao Nhất",
    "unlock_stats.on": "vào",
    "unlock_stats.chart_title": "Biểu Đồ Mở Khóa Pi - 30 Ngày Tới",
    "unlock_stats.data_table": "Bảng Dữ Liệu Mở Khóa",
    "unlock_stats.date": "Ngày",
    "unlock_stats.amount": "Số lượng",
    "unlock_stats.value": "Giá trị",
    "unlock_stats.pi_unlock": "Mở Khóa Pi",
    "unlock_stats.y_axis_label": "Mở khóa Pi (theo triệu)",
    "unlock_stats.monthly_heading": "Thống kê mở khóa Pi hàng tháng",
    "unlock_stats.monthly_title": "Thống kê mở khóa Pi hàng tháng",
    "unlock_stats.total_next_12": "Tổng 12 tháng tới",
    "unlock_stats.monthly_description": "Xem thống kê mở khóa tiền điện tử Pi theo tháng",
    "unlock_stats.monthly_intro_text": "Xem thống kê mở khóa tiền điện tử Pi theo tháng.",
    "unlock_stats.monthly_note": "Các thống kê dựa trên yêu cầu mở khóa hợp lệ.",
    "unlock_stats.monthly_chart_title": "Thống kê mở khóa Pi theo tháng",
    "unlock_stats.total_forecast": "Tổng thống kê",
    "unlock_stats.monthly_data_table": "Dữ liệu mở khóa hàng tháng",
    "unlock_stats.total_locking": "Tổng lượng khóa",
    "unlock_stats.avg_monthly": "Trung bình hàng tháng",
    "unlock_stats.highest_month": "Tháng cao nhất",
    "unlock_stats.per_month": "mỗi tháng",
    "unlock_stats.in": "trong",
    "unlock_stats.month": "Tháng",
    "unlock_stats.view_daily": "Xem thống kê mở khóa hàng ngày",
    "unlock_stats.view_monthly": "Xem thống kê mở khóa hàng tháng",
    "common.loading_error": "Lỗi khi tải dữ liệu. Vui lòng thử lại sau.",
    'settings.aria_label': 'Mở cài đặt',
    'settings.language': 'Ngôn ngữ',
    'settings.appearance': 'Giao diện',
    'settings.dark_mode': 'Chế độ tối',
    'settings.light': 'Sáng',
    'settings.dark': 'Tối',

    "transactios.heading": "Khám phá các giao dịch mới nhất trên blockchain Pi Network",
    "transactions.title": "Các Giao Dịch Mới Nhất trên Pi Network",
    "transactions.description": "Khám phá các giao dịch mới nhất trên blockchain Pi Network.",
    "domain_auction_stats.heading": "Thống kê Đấu giá Tên miền Pi",
"domain_auction_stats.title": "Thống kê Đấu giá Tên miền Pi | Thống kê Pi Network",
"domain_auction_stats.description": "Phân tích các phiên đấu giá tên miền trên Pi Network, hiển thị sự phân bố các giá thầu theo các mức giá khác nhau và tổng số Pi đã được đặt giá.",
"domain_auction_stats.intro_text": "Trang này cung cấp phân tích về các phiên đấu giá tên miền Pi, làm nổi bật sự phân bố của các giá thầu theo các mức giá khác nhau.",
"domain_auction_stats.last_updated": "Cập nhật lần cuối",
"domain_auction_stats.summary_title": "Tóm tắt Giá thầu Đấu giá",
"domain_auction_stats.total_bids": "Tổng số giá thầu",
"domain_auction_stats.total_pi_bid": "Tổng số Pi đã đặt giá",
"domain_auction_stats.estimated_value": "Giá trị ước tính (USD)",
"domain_auction_stats.pi_price": "Giá Pi hiện tại",
"domain_auction_stats.distribution_title": "Phân bố Giá thầu",
"domain_auction_stats.chart_title": "Phân bố Mức giá thầu",
"domain_auction_stats.details_title": "Chi tiết Giá thầu Trực tiếp",
"domain_auction_stats.bids": "giá thầu",
"domain_auction_stats.of_total": "trong tổng số giá thầu",
"domain_auction_stats.bid_count": "Số lượng Giá thầu",
"domain_auction_stats.ranges.low": "Giá thầu Thấp",
"domain_auction_stats.ranges.medium": "Giá thầu Trung bình",
"domain_auction_stats.ranges.high": "Giá thầu Cao cấp",
"domain_auction_stats.ranges.premium": "Giá thầu Sang trọng",
"domain_auction_stats.ranges.elite": "Giá thầu Đặc biệt",
"domain_auction_stats.table.price_range": "Khoảng Giá thầu",
"domain_auction_stats.table.bid_count": "Số lượng Giá thầu",
"domain_auction_stats.table.percentage": "Phần trăm",
"domain_auction_stats.table.total": "Tổng số Giá thầu",
"domain_auction_stats.highest_bid": "Giá thầu Cao nhất",
"domain_auction_stats.top_bids_title": "Các Giá thầu Hàng đầu",
"domain_auction_stats.table.account": "Tài khoản",
"domain_auction_stats.table.bid_amount": "Giá thầu",
"domain_auction_stats.table.usd_value": "Giá trị (USD)",
"largest_tx.heading": "Giao dịch Pi lớn nhất (24h qua)",
"largest_tx.title": "Giao dịch Pi lớn nhất trong 24 giờ qua - PiScan",
"largest_tx.description": "Khám phá các giao dịch Pi lớn nhất trên blockchain Pi Network trong 24 giờ qua.",
"largest_tx.list_heading": "Top giao dịch theo số lượng (24h qua)",
"largest_tx.rank": "Hạng",
"largest_tx.transaction": "Giao dịch",
"largest_tx.account": "Tài khoản",
"largest_tx.amount": "Số lượng (π)",
"largest_tx.date": "Ngày & Giờ",
"largest_tx.no_data": "Không có dữ liệu giao dịch nào trong 24 giờ qua.",
"largest_tx.fetch_error": "Không thể tải dữ liệu giao dịch.",
"largest_tx.loading": "Đang tải các giao dịch lớn nhất...",
"largest_tx.largest_amount": "Giao dịch có số lượng lớn nhất (24h qua)",
"largest_tx.latest_large_tx": "Giao dịch lớn gần nhất (24h qua)",
"largest_tx.total_value": "Tổng giá trị (Top 100 giao dịch trong 24h qua)",

"migrate_stats.heading": "Thống kê di chuyển Pi",
"migrate_stats.title": "Thống kê di chuyển Pi sang Mainnet - PiScan",
"migrate_stats.description": "Theo dõi thống kê di chuyển Pi hàng ngày sang Mainnet trong những ngày gần đây.",
"migrate_stats.last_updated": "Cập nhật lần cuối",

"migrate_stats.daily_migration": "Lượng Pi di chuyển mỗi ngày",
"migrate_stats.daily_stats": "Thống kê di chuyển theo ngày",
"migrate_stats.loading": "Đang tải thống kê di chuyển...",
"migrate_stats.no_data": "Không có dữ liệu di chuyển.",
"migrate_stats.fetch_error": "Không thể tải dữ liệu di chuyển.",
"migrate_stats.date": "Ngày",
"migrate_stats.amount": "Số lượng (π)",
"migrate_stats.percentage": "Tỷ lệ (%)",
"migrate_stats.total": "Tổng cộng",
"migrate_stats.pi_migrated": "Tổng số Pi đã di chuyển",
"migrate_stats.date_label": "Ngày: {{date}}",
"migrate_stats.usd_value": "Giá trị USD",
"migrate_stats.at_price": "theo giá hiện tại là",
"migrate_stats.current_price_note": "Giá trị USD được tính theo giá Pi hiện tại là {{price}} mỗi π.",
"transactions_filter.heading": "Lọc giao dịch",
"transactions_filter.title": "Lọc giao dịch | Pi Scan",
"transactions_filter.description": "Lọc và tìm kiếm các giao dịch Pi Network theo địa chỉ, số lượng và các tiêu chí khác.",
"transactions_filter.address_required_error": "Vui lòng nhập địa chỉ.",
"transactions_filter.min_amount_required_error": "Vui lòng nhập số lượng tối thiểu.",
"transactions_filter.amount_too_low_error": "Số lượng không thể nhỏ hơn 10.000",
"transactions_filter.min_exceeds_max_error": "Số lượng tối thiểu không được lớn hơn số lượng tối đa",
"transactions_filter.filter_options": "Tùy chọn lọc",
"transactions_filter.address": "Địa chỉ",
"transactions_filter.address_placeholder": "Nhập địa chỉ tài khoản",
"transactions_filter.min_amount": "Số lượng tối thiểu (Pi)",
"transactions_filter.min_amount_placeholder": "ví dụ: 10000",
"transactions_filter.max_amount": "Số lượng tối đa (Pi)",
"transactions_filter.max_amount_placeholder": "ví dụ: 100000",
"transactions_filter.apply_filters": "Áp dụng",
"transactions_filter.clear": "Xóa",
"transactions_filter.no_results": "Không tìm thấy giao dịch nào phù hợp với tiêu chí của bạn.",
"transactions_filter.results": "Kết quả",
"transactions_filter.table.hash": "Mã giao dịch",
"transactions_filter.table.time": "Thời gian",
"transactions_filter.table.from": "Từ",
"transactions_filter.table.to": "Đến",
"transactions_filter.table.amount": "Số lượng (Pi)",
"transactions_filter.apply_filters_prompt": "Vui lòng áp dụng bộ lọc để xem kết quả.",

// Assets page translations
'assets.heading': 'Tài sản Pi Network (Tokens)',
'assets.title': 'Tài sản Pi Network (Tokens)',
'assets.description': 'Khám phá tất cả tài sản (tokens) trên blockchain Pi Network',
'assets.total_assets': 'Tổng số tài sản (Tokens)',
'assets.showing_results': 'Hiển thị {{count}} trong {{total}} tài sản',
'assets.search_placeholder': 'Tìm kiếm theo mã tài sản hoặc người phát hành...',
'assets.assets_list': 'Danh sách tài sản',
'assets.previous': 'Trước',
'assets.next': 'Tiếp',
'assets.asset_code': 'Mã tài sản',
'assets.type': 'Loại',
'assets.issuer': 'Người phát hành',
    'assets.accounts': 'Tài khoản',
    'assets.holders': 'Holders',
    'assets.total_supply': 'Tổng cung',
    'assets.in_pools': 'Trong Pools',
    'assets.circulating': 'Lưu thông',
    'assets.pools': 'Pools',
    'assets.actions': 'Hành động',
    'assets.view_toml': 'Xem TOML',
    'assets.testnet_warning': 'Đây là các token trên testnet, và không có giá trị thực tế',

// Trades page translations
'trades.heading': 'Giao dịch Pi Network',
'trades.title': 'Giao dịch Pi Network',
'trades.description': 'Khám phá hoạt động giao dịch trên blockchain Pi Network',
'trades.total_trades': 'Hoạt động giao dịch',
'trades.showing_results': 'Hiển thị {{count}} trong {{total}} giao dịch',
'trades.search_placeholder': 'Tìm kiếm theo tài sản hoặc tài khoản...',
'trades.trades_list': 'Giao dịch gần đây',
'trades.exchange_rates': 'Tỷ giá hối đoái',
'trades.latest_rates': 'Tỷ giá mới nhất từ các giao dịch gần đây',
'trades.previous': 'Trước',
'trades.next': 'Tiếp',
'trades.time': 'Thời gian',
'trades.type': 'Loại',
'trades.summary': 'Tóm tắt giao dịch',
'trades.trading_pair': 'Cặp giao dịch',
'trades.amount': 'Số lượng',
'trades.price': 'Giá',
'trades.accounts': 'Tài khoản',
'trades.links': 'Liên kết',
'trades.sell_order': 'Bán',
'trades.buy_order': 'Mua',
'trades.base': 'Cơ sở',
'trades.counter': 'Đối ứng',
'trades.operation': 'Thao tác',
'trades.view_operation': 'Xem chi tiết thao tác',

// Asset Detail page translations
'assetDetail.heading': 'Chi tiết tài sản',
'assetDetail.back_to_assets': 'Quay lại danh sách tài sản',
'assetDetail.asset_info': 'Thông tin tài sản',
'assetDetail.total_supply': 'Tổng cung',
    'assetDetail.holders': 'Holders',
    'assetDetail.liquidity_pools': 'Pool thanh khoản',
    'assetDetail.claimable_balances': 'Số dư có thể claim',
    'assetDetail.in_pools': 'Trong Pools',
    'assetDetail.circulating': 'Lưu thông',
'assetDetail.trades': 'Giao dịch',
'assetDetail.search_trades': 'Tìm kiếm giao dịch...',
'assetDetail.previous': 'Trước',
'assetDetail.next': 'Tiếp',
'assetDetail.time': 'Thời gian',
'assetDetail.type': 'Loại',
'assetDetail.summary': 'Tóm tắt',
'assetDetail.price': 'Giá',
'assetDetail.accounts': 'Tài khoản',
'assetDetail.links': 'Liên kết',
'assetDetail.base': 'Cơ sở',
'assetDetail.counter': 'Đối tác',
'assetDetail.sell': 'Bán',
'assetDetail.buy': 'Mua',
'assetDetail.operation': 'Thao tác',
'assetDetail.view_operation': 'Xem thao tác',
'assetDetail.liquidity_pools_list': 'Danh sách nhóm thanh khoản',
'assetDetail.pool_id': 'ID Pool',
'assetDetail.reserves': 'Dự trữ',
'assetDetail.total_shares': 'Tổng cổ phần',
'assetDetail.fee': 'Phí',
'assetDetail.trustlines': 'Đường tin cậy',
'assetDetail.last_modified': 'Sửa đổi cuối',
'assetDetail.transactions': 'Giao dịch',
'assetDetail.operations': 'Thao tác',
'assetDetail.view_transactions': 'Xem giao dịch',
'assetDetail.view_operations': 'Xem thao tác',
'assetDetail.history': 'Lịch sử',
'assetDetail.no_pools_found': 'Không tìm thấy nhóm thanh khoản',
'assetDetail.testnet_warning': 'DỮ LIỆU TESTNET:',
'assetDetail.testnet_description': 'Đây là các hoạt động testnet và có thể không phản ánh hoạt động mainnet.',
'maintenance.heading': 'PiScan tạm thời bảo trì hệ thống',
'maintenance.title': 'PiScan - Bảo trì',
'maintenance.description': 'PiScan tạm thời dừng hoạt động trong quá trình hoàn tất nâng cấp giao thức lên phiên bản 23.',
'maintenance.status': 'Cập nhật dịch vụ',
'maintenance.page_title': 'PiScan đang thực hiện nâng cấp hệ thống',
'maintenance.message': 'Quá trình nâng cấp giao thức lên phiên bản 23 đang kéo dài hơn so với dự kiến ban đầu. Việc nâng cấp này ảnh hưởng đến hạ tầng index và các dịch vụ phân tích dữ liệu on-chain. Vì vậy, PiScan sẽ tạm thời dừng hoạt động trong vài ngày để hoàn tất và kiểm tra quá trình nâng cấp.',
'maintenance.protocol_label': 'Phiên bản giao thức',
'maintenance.protocol_value': 'Protocol v23',
'maintenance.affected_label': 'Dịch vụ bị ảnh hưởng',
'maintenance.affected_value': 'Indexing & On-chain Analytics',
'maintenance.eta_label': 'Dự kiến hoàn thành',
'maintenance.eta_value': '15/05',
'maintenance.note': 'Website dự kiến sẽ hoạt động trở lại sau khi quá trình nâng cấp hoàn tất. Cảm ơn bạn đã kiên nhẫn và thông cảm.'

  }
